export enum Location {
  US = 'US',
  GB = 'GB',
  AU = 'AU',
  EU = 'EU',
}

export enum Currency {
  USD = 'USD',
  AUD = 'AUD',
  GBP = 'GBP',
  EUR = 'EUR',
}

export type UpgradeQueryParams = {
  location?: Location
  countryCode?: string
  region?: string
}

export type LocationPlan = {
  [key in Location]: { itemId: string; price: string }
}
